import { ErrorResponse } from '@gtpl/shared-models/common-models';
import { Injectable } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import { Raw, Repository } from 'typeorm';
import { IdProofTypes } from './id-proofs-type.entity';
import { IdProofTypesAdapter } from './dto/id-proof-types.adapter';
import { IdProofTypesDTO } from './dto/id-proof-types.dto';
import { IdProofsTypeResponseModel, AllIdProofTypesResponseModel } from '@gtpl/shared-models/masters';
import { IdProofTypeRequest } from './dto/id-proof-types.request';
import { LogsService } from '@gtpl/shared-services/user-logs';
import { LogsDto } from 'libs/shared-models/user-logs/src/lib/Logs/logs.dto';
@Injectable()
export class IdProofsService {
    constructor(
      private logService:LogsService,

        @InjectRepository(IdProofTypes)
        private idProofTypeRepository: Repository<IdProofTypes>,
        private idProofTypesAdapter: IdProofTypesAdapter,
      ) {}
    /**
     * create/update idProofType
     * @param idProofTypesDTO 
     * @param isUpdate 
     * @param request 
     */
    async createIdProof(idProofTypesDTO: IdProofTypesDTO, isUpdate: boolean,request:Request): Promise<IdProofsTypeResponseModel> {
        try {
            console.log(isUpdate);
            // to check whether IdProofTypes exists with the passed  IdProofTypes  or not. if isUpdate is false, a check will be done whether a record with the passed IdProofTypes is existing or not. if a record exists then a return message wil be send with out saving the data.  if record is not existing with the passed IdProofTypes  then a new record will be created. if isUpdate is true, then no check will be performed and  record will be updated(if record exists with the passed cluster code) or created.
            if (!isUpdate) {
                const IdProofTypeEntity = await this.getIdProofTypeDetailsWithoutRelations(idProofTypesDTO.idProofType);
                if (IdProofTypeEntity) {
                    throw new ErrorResponse(11104, 'Id Proof Type already exists');         
                } 
            // var notificationStatus='Created';
            }else{
                const idProofTypeEntity = await this.getIdProofTypeDetailsWithoutRelations(idProofTypesDTO.idProofType);
                if(idProofTypeEntity){
                    if(idProofTypeEntity.idProofTypeId!=idProofTypesDTO.idProofTypeId) {
                        throw new ErrorResponse(11104, 'Id Proof Type already exists');      
                    }
                }
            }

            // else{
            // var notificationStatus='Updated';
            // }
            const convertedIdProofTypeEntity: IdProofTypes = this.idProofTypesAdapter.convertDtoToEntity(idProofTypesDTO,isUpdate);
            const savedIdProofTypeEntity: IdProofTypes = await this.idProofTypeRepository.save(
                convertedIdProofTypeEntity
            );
            const savedIdProofTypeDto: IdProofTypesDTO = this.idProofTypesAdapter.convertEntityToDto(savedIdProofTypeEntity);
            if (savedIdProofTypeDto) {
            // generating resposnse
            const response = new IdProofsTypeResponseModel(true,isUpdate ? 11101 : 11100,isUpdate? 'Id Proof Type Updated Successfully': 'Id Proof Type Created Successfully',savedIdProofTypeDto);
            const name=isUpdate?'updated':'created'
            
            const newLogDto = new LogsDto(1,name, 'IdProofTypes', savedIdProofTypeDto.idProofTypeId, true, '',savedIdProofTypeDto.createdUser)
            let res = await this.logService.createLog(newLogDto);
            console.log(res);
            return response;
            } else {
            throw new ErrorResponse(11106,'Id Proof Type saved but issue while transforming into DTO');
            }
        } catch (error) {
            // when error occures while saving the data , the execution will come to catch block.
            // tslint:disable-next-line: typedef
            throw error;
        }
    }
    /**
     * get id proof type details
     * @param idProofType 
     */
    // @LogActions({isAsync: true})
    async getIdProofTypeDetailsWithoutRelations(idProofType: string): Promise<IdProofTypes> {
        // tslint:disable-next-line: typedef
        const idProofTypeResponse = await this.idProofTypeRepository.findOne({
        where: {idProofType: Raw(alias => `id_proof_type = '${idProofType}'`)},
        });
        if (idProofTypeResponse) {
        return idProofTypeResponse;
        } else {
        return null;
        }
    }

     /**
     * gets all IdProofTypes details  
     * @returns AllIdProofTypesResponseModel details .
     */
    async getAllIdProofs(): Promise<AllIdProofTypesResponseModel> {
        // const page: number = 1;
        try {
          const idProofTypesDTO: IdProofTypesDTO[] = [];
          //retrieves all companies
          const idProofTypesEntities: IdProofTypes[] = await this.idProofTypeRepository.find({order :{'createdAt':'DESC'}});
          //console.log(idProofTypesEntities);
          if (idProofTypesEntities) {
            // converts the data fetched from the database which of type companies array to type StateDto array.
            idProofTypesEntities.forEach(idProofTypeEntity => {
              const convertedstatesDto: IdProofTypesDTO = this.idProofTypesAdapter.convertEntityToDto(
                idProofTypeEntity
              );
              idProofTypesDTO.push(convertedstatesDto);
            });
            const response = new AllIdProofTypesResponseModel(true,11108,"Id Proofs retrieved successfully",idProofTypesDTO);
            const newLogDto = new LogsDto(1,'view', 'IdProofTypes', 0, true, '','')
            let res = await this.logService.createLog(newLogDto);
            console.log(res);
            return response;
          } else {
            throw new ErrorResponse(99998, 'Data not found');
          }
        } catch (err) {
          throw err;
        }
      }

    /**
     * It deactivates Id proof type 
     * @returns true or false
     */
    // @LogActions({isAsync: true})
    async activateorDeactivateIdProof(idProofTypeReq: IdProofTypeRequest): Promise<IdProofsTypeResponseModel> {
      try {
          const idProofTypeExists = await this.getIdProofById(idProofTypeReq.idProofTypeId);
          if (idProofTypeExists) {
              if (idProofTypeReq.versionFlag !== idProofTypeExists.versionFlag) {
                  throw new ErrorResponse(10113, 'Someone updated the current Id Proof. Refresh and try again');
              } else {
                  
                      const idProofTypeStatus =  await this.idProofTypeRepository.update(
                          { idProofTypeId: idProofTypeReq.idProofTypeId },
                          { isActive: idProofTypeReq.isActive,updatedUser: idProofTypeReq.updatedUser });
                     
                      if (idProofTypeExists.isActive) {
                          if (idProofTypeStatus.affected) {
                              const idProofTypeResponse: IdProofsTypeResponseModel = new IdProofsTypeResponseModel(true, 10115, 'Id Proof is de-activated successfully');
                              return idProofTypeResponse;
                          } else {
                              throw new ErrorResponse(10111, 'Id Proof is already deactivated');
                          }
                      } else {
                          if (idProofTypeStatus.affected) {
                              const idProofTypeResponse: IdProofsTypeResponseModel = new IdProofsTypeResponseModel(true, 10114, 'Id Proof is activated successfully');
                              return idProofTypeResponse;
                          } else {
                              throw new ErrorResponse(10112, 'Id Proof is already activated');
                          }
                      }
                  // }
              }
          } else {
              throw new ErrorResponse(99998, 'No Records Found');
          }
      } catch (err) {
          throw err;
      }
  }
  /**
   * get id proof while passing id
   * @param idProofTypeId 
   */
  async getIdProofById(idProofTypeId: number): Promise<IdProofTypes> {
        const Response = await this.idProofTypeRepository.findOne({
        where: {idProofTypeId: idProofTypeId},
        });
        if (Response) {
        return Response;
        } else {
        return null;
        }
    }
      
}
